import React from 'react';
import {useQuery} from '@tanstack/react-query';
import {Typography} from '@mui/material';
import {PaperWrapper} from '../../atoms/PaperWrapper/PaperWrapper';
import {getShiftCostRange} from '../../Forecast/SalaryForecast/api';

const Cost = ({value}) => !value?.available ? 'Unavailable' : <>
  {value.costs.map((cost, index) => <React.Fragment key={cost.currencySymbol}>
    {index > 0 && ' · '}
    {cost.currencySymbol}{cost.amount.toLocaleString('en-GB', {minimumFractionDigits: 2, maximumFractionDigits: 2})}
    {!cost.currencySymbol && ' (currency unspecified)'}
  </React.Fragment>)}
  {value.missingCostShifts > 0 && <Typography component="span" variant="caption" color="warning.main">
    {' '}Partial · {value.costedShifts}/{value.shiftCount} shifts costed
  </Typography>}
</>;

export default function SalaryFigure({siteId, from, to, sales}) {
  const enabled = Boolean(siteId && from && to);
  const {data, isLoading, error} = useQuery({
    queryKey: ['dashboardShiftCosts', siteId, from, to],
    queryFn: () => getShiftCostRange(siteId, from, to), enabled
  });
  const summary = error ? undefined : data?.data;
  const actual = summary?.actual;
  const loading = enabled && isLoading;
  const percentage = actual?.available && !actual.missingCostShifts &&
    actual.costs.length === 1 && actual.costs[0].currencySymbol === '£' && sales > 0
    ? (actual.costs[0].amount / sales * 100).toFixed(1) : null;

  return <PaperWrapper heading="Salary" loading={loading}>
    <div style={{fontSize: '2rem', textAlign: 'left'}}>
      {loading ? 'Loading…' : <Cost value={actual} />}
    </div>
    <div style={{marginTop: 5, fontSize: 13}}>
      {percentage !== null && `${percentage}% of Sales, `}
      Fcst: {loading ? 'Loading…' : <Cost value={summary?.forecast} />}
    </div>
    {error && <Typography variant="caption" color="error">Unable to load shift costs.</Typography>}
    {summary?.supported === false && <Typography variant="caption" color="text.secondary">
      Salary figures before {summary.reportingStartDate} are unavailable.
    </Typography>}
  </PaperWrapper>;
}
